var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Any, JsonObject, JsonProperty } from 'json2typescript';
var WebhookOptions = (function () {
    function WebhookOptions(partial) {
        this.secret = undefined;
        this.httpMethod = undefined;
        this.validationMethod = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('secret', String, true),
        __metadata("design:type", String)
    ], WebhookOptions.prototype, "secret", void 0);
    __decorate([
        JsonProperty('httpMethod', String, true),
        __metadata("design:type", String)
    ], WebhookOptions.prototype, "httpMethod", void 0);
    __decorate([
        JsonProperty('validationMethod', String, true),
        __metadata("design:type", String)
    ], WebhookOptions.prototype, "validationMethod", void 0);
    WebhookOptions = __decorate([
        JsonObject('WebhookOptions'),
        __metadata("design:paramtypes", [Object])
    ], WebhookOptions);
    return WebhookOptions;
}());
export { WebhookOptions };
var IncomingWebhook = (function () {
    function IncomingWebhook(partial) {
        this.id = undefined;
        this.name = '';
        this.functionSource = '';
        this.lastModified = undefined;
        this.canEvaluate = {};
        this.runAsUserId = '';
        this.runAsUserIdScriptSource = '';
        this.runAsAuthedUser = false;
        this.options = new WebhookOptions();
        this.respondResult = false;
        this.disableArgLogs = false;
        this.fetchCustomUserData = false;
        this.createUserOnAuth = false;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id', String, true),
        __metadata("design:type", String)
    ], IncomingWebhook.prototype, "id", void 0);
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "name", void 0);
    __decorate([
        JsonProperty('function_source'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "functionSource", void 0);
    __decorate([
        JsonProperty('last_modified', Number, true),
        __metadata("design:type", Number)
    ], IncomingWebhook.prototype, "lastModified", void 0);
    __decorate([
        JsonProperty('can_evaluate', Any, true),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "canEvaluate", void 0);
    __decorate([
        JsonProperty('run_as_user_id'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "runAsUserId", void 0);
    __decorate([
        JsonProperty('run_as_user_id_script_source'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "runAsUserIdScriptSource", void 0);
    __decorate([
        JsonProperty('run_as_authed_user'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "runAsAuthedUser", void 0);
    __decorate([
        JsonProperty('options', WebhookOptions, true),
        __metadata("design:type", WebhookOptions)
    ], IncomingWebhook.prototype, "options", void 0);
    __decorate([
        JsonProperty('respond_result'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "respondResult", void 0);
    __decorate([
        JsonProperty('disable_arg_logs', Boolean, true),
        __metadata("design:type", Boolean)
    ], IncomingWebhook.prototype, "disableArgLogs", void 0);
    __decorate([
        JsonProperty('fetch_custom_user_data'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "fetchCustomUserData", void 0);
    __decorate([
        JsonProperty('create_user_on_auth'),
        __metadata("design:type", Object)
    ], IncomingWebhook.prototype, "createUserOnAuth", void 0);
    IncomingWebhook = __decorate([
        JsonObject('IncomingWebhook'),
        __metadata("design:paramtypes", [Object])
    ], IncomingWebhook);
    return IncomingWebhook;
}());
export { IncomingWebhook };
var PartialIncomingWebhook = (function () {
    function PartialIncomingWebhook() {
        this.id = '';
        this.name = '';
        this.lastModified = undefined;
    }
    __decorate([
        JsonProperty('_id', String, true),
        __metadata("design:type", Object)
    ], PartialIncomingWebhook.prototype, "id", void 0);
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], PartialIncomingWebhook.prototype, "name", void 0);
    __decorate([
        JsonProperty('last_modified', Number, true),
        __metadata("design:type", Number)
    ], PartialIncomingWebhook.prototype, "lastModified", void 0);
    PartialIncomingWebhook = __decorate([
        JsonObject('PartialIncomingWebhook')
    ], PartialIncomingWebhook);
    return PartialIncomingWebhook;
}());
export { PartialIncomingWebhook };
//# sourceMappingURL=IncomingWebhook.js.map